import { ComponentProps, ReactNode } from 'react';
import { Text } from './Text';
import clsx from 'clsx';
import { textVariantClasses } from './Text';

interface TextAreaProps extends ComponentProps<'textarea'> {
  name?: string;
  label?: string;
  error?: boolean | string;
  textAreaClassName?: string;
  leftIcon?: ReactNode;
  rightIcon?: ReactNode;
}

export function TextArea({
  name,
  label,
  className,
  textAreaClassName,
  error,
  leftIcon,
  rightIcon,
  ...props
}: TextAreaProps) {
  return (
    <div className={className}>
      {label && (
        <Text
          as="label"
          variant="label"
          strong
          className={clsx('mb-2xs block', name && 'cursor-pointer')}
          htmlFor={name}
        >
          {label}
        </Text>
      )}
      <div
        className={clsx(
          'py-xs pl-sm pr-3xs border-transparent-dark-16 bg-base-white focus-within:border-neutral-default outline-neutral-subtle has-disabled:bg-transparent-dark-6 gap-2xs flex items-center rounded-md border shadow-xs transition-all duration-150 ease-in-out focus-within:outline-2 focus-within:outline-offset-2',
          error && '!border-error-default',
          textVariantClasses['label-sm-default'],
          textAreaClassName
        )}
      >
        {leftIcon}
        <textarea
          {...props}
          className={clsx(
            'placeholder:text-neutral-muted custom-scrollbar h-full w-full resize-none outline-0',
            error && 'text-error-default placeholder:!text-error-default'
          )}
          id={name}
          name={name}
          rows={4}
        />
        {rightIcon}
      </div>
      {typeof error === 'string' && error.length > 0 && (
        <Text as="span" variant="label" size="xs" className="text-error-default">
          {error}
        </Text>
      )}
    </div>
  );
}
